import React, {useEffect, useState} from "react";
import AnalyticsScreen from './MainAnalytics';
import MapScreen from "./MapScreen";

interface MainDisplayProps {
    activeControl: string;
    // activeView: string;
    // visibleWidgets: { alerts: boolean; layers: boolean; legend: boolean };
    // onWidgetToggle: (widget: "alerts" | "layers" | "legend", isVisible: boolean) => void;  
}

const MainDisplay: React.FC<MainDisplayProps> = ({ activeControl }) => {
  const [regionId, setRegionId] = useState<string>('LSG000001'); 
  const [widgetsVisible, setWidgetsVisible] = useState(true);

//   useEffect(()=>{console.log("MapScreen:", widgetsVisible);}, [widgetsVisible]);
console.log("MainDisplay:",widgetsVisible);

    
  // Render based on active control and active view
  if (activeControl === 'map') {
     return <MapScreen
     regionId = {regionId}
     setRegionId = {setRegionId}
     widgetsVisible={widgetsVisible}
     setWidgetsVisible={setWidgetsVisible}
     />;
    // Add conditions for other views like analytics, settings, etc.
}
// if (activeControl === 'Forecast') {
//     if (activeView === 'Visualization') return <ForecastScreen />;
// }
if (activeControl === 'analytics') {
    return <AnalyticsScreen
        regionId = {regionId}
        setRegionId = {setRegionId}
    />;
}

// Default to the Monitoring map if no matching case
return <MapScreen
    regionId = {regionId}
    setRegionId = {setRegionId}
    widgetsVisible={widgetsVisible}
    setWidgetsVisible={setWidgetsVisible}
/>;
};

export default MainDisplay;